import PropTypes from 'prop-types';
import React from 'react';
import CommonLayout from '../common/layouts/commonLayout';
import GoButton from '../common/components/GoButton';
import { ARIA_LABELS } from '../constants/text';

const RANDirectionsView = props => (
    <CommonLayout>
        <div className="directions-view">
            <h1 className="directions-header direction-text-bold">Directions</h1>
            <ul className="directions-list">
                <li className="direction-item">
                    This assessment must be individually administered.
                </li>
                <li className="direction-item">
                    <span className="direction-text-bold">Prompts:</span>
                    <ul className="directions-list">
                        <li>
                            During the practice step, if the student says an incorrect number,
                            provide the correct response and say{' '}
                            <span className="direction-text-italic">keep going</span>.
                        </li>
                        <li>
                            During the assessment, if the student hesitates 3 seconds, mark the item
                            as incorrect, provide the correct response and say{' '}
                            <span className="direction-text-italic">keep going</span>.
                        </li>
                    </ul>
                </li>
                <li className="direction-item">
                    Click <span className="direction-text-bold">OK</span> to begin the assessment.
                </li>
            </ul>
        </div>
        <GoButton onClick={props.onNext} ariaLabel={ARIA_LABELS.GO_TO_NEXT_STEP} />
    </CommonLayout>
);

RANDirectionsView.propTypes = {
    onNext: PropTypes.func,
};

RANDirectionsView.defaultProps = {
    onNext: () => {},
};

export default RANDirectionsView;
